import { useTranslation } from 'react-i18next';
import { whatsappLink, googleMapsLink } from '@/mocks/gymInfo';

export default function MobileBar() {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-foreground-950 border-t border-foreground-900/50" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex items-center">
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-hover flex-1 flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-950 font-body text-sm font-semibold py-3.5"
        >
          <i className="ri-whatsapp-line text-lg"></i>
          {t('mobile.whatsapp')}
        </a>
        <a
          href={googleMapsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-hover flex-1 flex items-center justify-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-body text-sm font-medium py-3.5"
        >
          <i className="ri-map-pin-line text-lg"></i>
          {t('mobile.directions')}
        </a>
      </div>
    </div>
  );
}